var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NotificationQueue',{attrs:{"items":_vm.items},on:{"remove":_vm.removeItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }